import { useEffect, useRef } from 'react';

/**
 * Reloads the page data when the browser restores the page from its back/forward cache
 * (`pageshow` with `persisted`): the library and the detail page are separate documents,
 * so "back" after saving an asset would otherwise show the state from before the save.
 */
function useRefetchOnPageRestore(refetch: () => unknown) {
    const refetchRef = useRef(refetch);
    refetchRef.current = refetch;

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) {
                refetchRef.current();
            }
        };
        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);
}

export { useRefetchOnPageRestore };
